import { HeaderCellModel } from '../types';
import { colors } from '@ardoq/design-tokens';

const getRowHeaderCellStyle = (headerCell: HeaderCellModel) => {
  const level = headerCell.indexAddress.length - 1;
  return level === 0 ? { borderBottom: `1px solid ${colors.grey300}` } : {};
};

export { getRowHeaderCellStyle };
